<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="agenda-card" body-classes="agenda-card-body">
            <template slot="header">
              <div class="row align-items-center">
                <div class="col-12">
                  <h4 class="card-title">
                    <i class="icon-svg icon-calendar"></i>{{ $t("agenda") }}
                  </h4>
                </div>
              </div>
            </template>
            <div class="row agenda-layout">
              <div class="col-lg-9 col-12 agenda-calendar-panel">
                <div class="agenda-calendar">
                  <FullCalendar :options="calendarOptions" ref="fullCalendar" />
                </div>
              </div>

              <div class="col-lg-3 col-12 mt-3 mt-lg-0 pl-lg-2 agenda-filters-col">
                <div class="agenda-filters-panel">
                  <div class="agenda-filters-header">{{ $t("categorias") }}</div>
                  <div class="agenda-filters-body">
                    <div
                      v-for="cat in categoriasPanel"
                      :key="cat.id"
                      class="agenda-cat-item mb-3"
                    >
                      <div class="agenda-cat-row">
                        <label class="cd-checkbox cd-checkbox--field d-flex">
                          <input
                            type="checkbox"
                            v-model="cat.visible"
                            @change="filtrarEventos"
                          />
                          <span class="cd-checkbox__mark"></span>
                          <span class="agenda-cat-color-dot" :style="{ backgroundColor: cat.color || '#2E9E4F' }"></span>
                          <span class="cd-checkbox__text">{{ cat.nombre }}</span>
                        </label>
                        <div class="agenda-cat-row-actions">
                          <button
                            type="button"
                            class="btn btn-edit-outline"
                            v-tooltip="$t('edit')"
                            @click="onEditarCategoria(cat)"
                          >
                            <i class="icon-svg icon-edit"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-delete-outline"
                            v-tooltip="$t('Eliminar')"
                            @click="onEliminarCategoria(cat)"
                          >
                            <i class="icon-svg icon-trash"></i>
                          </button>
                        </div>
                      </div>
                      <div v-if="editingCategoriaId === cat.id" class="agenda-cat-edit-box mt-2">
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="editingCatNombre"
                          placeholder="Nombre de la categoría"
                          @keyup.enter="onGuardarEdicionCategoria(cat)"
                        />
                        <div class="agenda-cat-edit-color">
                          <input
                            type="color"
                            v-model="editingCatColor"
                            class="agenda-color-input"
                          />
                          <span class="agenda-cat-edit-color-label">Color de la categoría</span>
                        </div>
                        <div class="nueva-cat-actions">
                          <button
                            type="button"
                            class="btn btn-sm btn-secondary"
                            @click="onCancelarEditarCategoria"
                          >
                            {{ $t('Cancelar') }}
                          </button>
                          <button
                            type="button"
                            class="btn btn-sm btn-primary"
                            :disabled="savingCatEdit"
                            @click="onGuardarEdicionCategoria(cat)"
                          >
                            <i class="fa fa-spinner fa-spin" v-if="savingCatEdit"></i>
                            <span v-else>{{ $t('Guardar') }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Modal nuevo/editar evento -->
            <modal
              class="cd-modal"
              v-if="showModalEvento"
              :showClose="true"
              :showBtnCancel="true"
              :btnCancelText="$t('Cancelar')"
              :title="eventoEditing ? 'Editar evento' : 'Nuevo evento'"
              :titleIcon="'icon-svg icon-calendar'"
              :btnAcceptText="saving ? $t('saving') : 'Guardar'"
              :btnAcceptDisabled="saving"
              :size="'md'"
              @close="onCerrarModalEvento"
              @accept="onGuardarEvento"
            >
                <!-- Only when editing: a new event has nothing to delete yet. -->
                <template slot="footer-left">
                  <button
                    v-if="eventoEditing"
                    type="button"
                    class="btn cd-modal-footer-delete"
                    :disabled="deleting"
                    @click="onEliminarEvento"
                  >
                    <i class="icon-svg icon-trash"></i>
                    <span>{{ deleting ? $t("deleting") : $t("Eliminar") }}</span>
                  </button>
                </template>

                <div class="form-group">
                  <label class="cd-form-label" for="eventoTitulo">{{ $t("titulo") }}</label>
                  <input
                    id="eventoTitulo"
                    type="text"
                    class="form-control"
                    v-model="eventoForm.title"
                  />
                </div>
                <div class="form-group">
                  <base-select
                    :label="$t('categoria')"
                    v-model="eventoForm.categoria_id"
                    :items="categoriasSeleccionables"
                    key_option="nombre"
                    :placeholder="$t('categoria')"
                  ></base-select>
                  <div v-if="!showNuevaCat" class="mt-1">
                    <a
                      href="#"
                      class="nueva-cat-link"
                      @click.prevent="showNuevaCat = true"
                    >
                      <i class="fa fa-plus"></i> Nueva categoría
                    </a>
                  </div>
                  <div v-else class="nueva-cat-box mt-2">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      placeholder="Nombre de la categoría"
                      v-model="nuevaCatNombre"
                      @keyup.enter="onGuardarCategoria"
                      ref="nuevaCatInput"
                    />
                    <div class="agenda-cat-edit-color">
                      <input
                        type="color"
                        v-model="nuevaCatColor"
                        class="agenda-color-input"
                      />
                      <span class="agenda-cat-edit-color-label">Color de la categoría</span>
                    </div>
                    <div class="nueva-cat-actions">
                      <button
                        type="button"
                        class="btn btn-sm btn-secondary"
                        @click="showNuevaCat = false; nuevaCatNombre = ''; nuevaCatColor = '#2E9E4F'"
                      >
                        Cancelar
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm btn-primary"
                        :disabled="savingCat"
                        @click="onGuardarCategoria"
                      >
                        <i class="fa fa-spinner fa-spin" v-if="savingCat"></i>
                        <span v-else>Guardar</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <base-select
                    :label="$t('Usuario')"
                    v-model="eventoForm.user_id"
                    :items="usuariosOptions"
                    :enabled="isAdmin"
                    :placeholder="$t('Usuario')"
                  ></base-select>
                </div>
                <div class="row">
                  <div class="form-group col-6">
                    <label class="cd-form-label">{{ $t("inicio") }}</label>
                    <ejs-datetimepicker
                      class="agenda-ejs-datetime"
                      :value="toPickerDate(eventoForm.start)"
                      :locale="'es'"
                      :format="'dd/MM/yyyy HH:mm'"
                      :openOnFocus="true"
                      :zIndex="10050"
                      timeFormat="HH:mm"
                      :step="15"
                      :showClearButton="true"
                      :placeholder="$t('selecciona_fecha_hora')"
                      @change="onStartDateTimeChange"
                    ></ejs-datetimepicker>
                  </div>
                  <div class="form-group col-6">
                    <label class="cd-form-label">{{ $t("fin") }}</label>
                    <ejs-datetimepicker
                      class="agenda-ejs-datetime"
                      :value="toPickerDate(eventoForm.end)"
                      :locale="'es'"
                      :format="'dd/MM/yyyy HH:mm'"
                      :openOnFocus="true"
                      :zIndex="10050"
                      timeFormat="HH:mm"
                      :step="15"
                      :showClearButton="true"
                      :placeholder="$t('selecciona_fecha_hora')"
                      @change="onEndDateTimeChange"
                    ></ejs-datetimepicker>
                  </div>
                </div>
                <div class="form-group">
                  <label class="cd-checkbox cd-checkbox--field">
                    <input type="checkbox" v-model="eventoForm.allDay" />
                    <span class="cd-checkbox__mark"></span>
                    <span class="cd-checkbox__text">{{ $t("todo_el_dia") }}</span>
                  </label>
                </div>
                <div class="form-group">
                  <label class="cd-form-label" for="eventoDescripcion">{{ $t("descripcion") }}</label>
                  <textarea
                    id="eventoDescripcion"
                    class="form-control"
                    rows="3"
                    v-model="eventoForm.description"
                  ></textarea>
                </div>
            </modal>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import esLocale from "@fullcalendar/core/locales/es";
import { DateTimePickerComponent } from "@syncfusion/ej2-vue-calendars";
import Modal from "@/components/Modal.vue";
import BaseSelect from "@/components/Inputs/BaseSelect.vue";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "AgendaView",
  components: {
    FullCalendar,
    Modal,
    BaseSelect,
    "ejs-datetimepicker": DateTimePickerComponent,
  },

  computed: {
    ...mapGetters({
      user: "login/user",
    }),
    isAdmin() {
      return Number(this.user?.rol_id) === 1;
    },
    // Categories shown in the side panel: only the ones used by the events the
    // current user owns or is assigned to. Admins keep seeing them all, since
    // they also see every event on the calendar.
    categoriasPanel() {
      if (this.isAdmin) {
        return this.categorias;
      }
      return this.categorias.filter((c) => this.idsCategoriasUsadas.has(c.id));
    },
    // Ids of the categories used by the events the current user owns or is
    // assigned to.
    idsCategoriasUsadas() {
      return new Set(
        this.todosEventos
          .filter((e) => this._esEventoDelUsuario(e))
          .map((e) => e.categoria_id),
      );
    },
    // Categories a non-admin can pick when creating or editing an event: the
    // ones they already use, plus any category they create from the modal
    // itself (which has no event yet), plus the one already set on the event
    // being edited so an existing value is never silently dropped.
    categoriasSeleccionables() {
      if (this.isAdmin) {
        return this.categorias;
      }
      return this.categorias.filter(
        (c) =>
          this.idsCategoriasUsadas.has(c.id) ||
          this.categoriasCreadasIds.includes(c.id) ||
          c.id === this.eventoForm.categoria_id,
      );
    },
    usuariosOptions() {
      return this.usuarios.map((u) => ({
        id: u.id,
        name: u.name || u.email || ("Usuario " + u.id),
      }));
    },
  },

  data() {
    return {
      showModalEvento: false,
      eventoEditing: null,
      eventoForm: {
        title: "",
        start: "",
        end: "",
        allDay: false,
        description: "",
        categoria_id: null,
        user_id: null,
      },
      saving: false,
      deleting: false,
      savingCat: false,
      savingCatEdit: false,
      showNuevaCat: false,
      nuevaCatNombre: "",
      nuevaCatColor: "#2E9E4F",
      editingCategoriaId: null,
      editingCatNombre: "",
      editingCatColor: "#2E9E4F",
      todosEventos: [], // todos los eventos de BD
      categorias: [], // [{ id, nombre, color, visible }]
      // Categories created from the event modal during this session: still
      // selectable even though no event uses them yet.
      categoriasCreadasIds: [],
      usuarios: [],
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
        locale: esLocale,
        initialView: "dayGridMonth",
        firstDay: 1,
        fixedWeekCount: false,
        showNonCurrentDates: true,
        dayMaxEvents: true,
        eventDisplay: "block",
        // "100%" (no un calc(100vh...) fijo) para que el calendario rellene
        // exactamente el alto real de .agenda-calendar-panel, cualquiera
        // que sea — con la fórmula fija anterior, ese cálculo no tenía por
        // qué coincidir con el alto real que el flexbox le da al panel (que
        // depende también del propio contenido, la barra del navegador,
        // etc.), dejando un hueco en blanco de ~12px antes del borde
        // inferior real del panel, que el de "Categorías" (sin ese
        // problema, es una simple caja) sí ocupaba entero.
        height: "100%",
        headerToolbar: {
          left: "prev,next",
          center: "title",
          right:
            "today,timeGridDay,timeGridWeek,dayGridMonth,listMonth printButton",
        },
        customButtons: {
          printButton: {
            text: "Imprimir",
            click: () => window.print(),
          },
        },
        buttonText: {
          today: "Hoy",
          month: "Mes",
          week: "Semana",
          day: "Dia",
          list: "Agenda",
        },
        dayHeaderFormat: { weekday: "long" },
        editable: true,
        selectable: true,
        events: [],
        // Click en fecha vacía → abrir modal nuevo evento
        dateClick: this.onDateClick,
        // Click en evento existente → editar
        eventClick: this.onEventClick,
        // Drag & drop para mover evento
        eventDrop: this.onEventDrop,
        // Drag para crear rango
        select: this.onSelect,
      },
    };
  },

  created() {
    this.cargarCategorias();
    this.cargarUsuarios();
    this.cargarEventos();
  },

  mounted() {
    // El calendario está a height:"100%" para rellenar el panel, con
    // celdas posicionadas por FullCalendar en position:absolute respecto a
    // ese alto — un CSS puro de impresión no puede reducirlo sin dejar el
    // grid en 0px (las celdas no tienen otra referencia de tamaño). Se
    // cambia a su modo 'auto' (el propio FullCalendar sabe crecer con el
    // contenido en ese modo) justo antes de imprimir y se devuelve al
    // salir del diálogo de impresión.
    this._onBeforePrint = () => {
      const api = this.$refs.fullCalendar?.getApi();
      if (api) {
        api.setOption("height", "auto");
      }
    };
    this._onAfterPrint = () => {
      const api = this.$refs.fullCalendar?.getApi();
      if (api) {
        api.setOption("height", "100%");
      }
    };
    window.addEventListener("beforeprint", this._onBeforePrint);
    window.addEventListener("afterprint", this._onAfterPrint);
  },

  beforeDestroy() {
    window.removeEventListener("beforeprint", this._onBeforePrint);
    window.removeEventListener("afterprint", this._onAfterPrint);
  },

  methods: {
    async cargarCategorias() {
      this.$store.dispatch("isLoadingOn");
      try {
        const { data } = await axios.get("/categories");
        this.categorias = data.map((c) => ({
          ...c,
          nombre: c.name,
          color: c.color || "#2E9E4F",
          visible: true,
        }));
      } catch (e) {
        this.$notify({
          type: "danger",
          message: e.response?.data?.message || this.$t("server_error"),
        });
      } finally {
        this.$store.dispatch("isLoadingOff");
      }
    },

    async cargarEventos() {
      this.$store.dispatch("isLoadingOn");
      try {
        const { data } = await axios.get("/events");
        this.todosEventos = data.map((e) => this._mapEvent(e));
        this.filtrarEventos();
      } catch (e) {
        this.$notify({
          type: "danger",
          message: e.response?.data?.message || this.$t("server_error"),
        });
      } finally {
        this.$store.dispatch("isLoadingOff");
      }
    },

    async cargarUsuarios() {
      if (!this.isAdmin) {
        this.usuarios = this.user?.id ? [this.user] : [];
        return;
      }

      try {
        const { data } = await axios.get("/user");
        this.usuarios = Array.isArray(data)
          ? data
          : Array.isArray(data?.data)
            ? data.data
            : [];
      } catch (e) {
        try {
          const { data } = await axios.get("/users");
          this.usuarios = Array.isArray(data)
            ? data
            : Array.isArray(data?.data)
              ? data.data
              : [];
        } catch (err) {
          this.usuarios = this.user?.id ? [this.user] : [];
        }
      }
    },

    // An event belongs to the current user when it is created for them or
    // assigned to them; admins can see every event.
    _esEventoDelUsuario(e) {
      return this.isAdmin || Number(e.user_id) === Number(this.user?.id);
    },

    // Mapea un evento de la API al formato interno + FullCalendar
    _mapEvent(e) {
      return {
        id: e.id,
        title: e.title,
        start: e.init_date,
        end: e.end_date,
        allDay: !!e.all_day,
        description: e.description,
        categoria_id: e.category_id,
        user_id: e.user_id || e.user?.id || this.user?.id,
        color: e.category?.color || "#2E9E4F",
      };
    },

    onCerrarModalEvento() {
      this.showModalEvento = false;
      this.showNuevaCat = false;
      this.nuevaCatNombre = "";
      this.deleting = false;
    },

    filtrarEventos() {
      const categoriasVisibles = new Set(
        this.categorias.filter((c) => c.visible).map((c) => c.id),
      );
      const eventosFiltrados = this.todosEventos
        .filter((e) => this._esEventoDelUsuario(e))
        .filter((e) => categoriasVisibles.has(e.categoria_id))
        .map((e) => {
          const cat = this.categorias.find((c) => c.id === e.categoria_id);
          return {
            ...e,
            backgroundColor: cat?.color || "#2E9E4F",
            borderColor: cat?.color || "#2E9E4F",
          };
        });

      // Actualizar eventos en FullCalendar de forma reactiva
      this.calendarOptions = {
        ...this.calendarOptions,
        events: eventosFiltrados,
      };
    },

    onNuevoEvento() {
      const nowDateTime = this.getNowLocalDateTime();
      this.eventoEditing = null;
      this.showNuevaCat = false;
      this.nuevaCatNombre = "";
      this.eventoForm = {
        title: "",
        start: nowDateTime,
        end: "",
        allDay: false,
        description: "",
        categoria_id: this.categoriasSeleccionables[0]?.id || null,
        user_id: this.user?.id || null,
      };
      this.showModalEvento = true;
    },

    getNowLocalDateTime() {
      const now = new Date();
      const tzOffsetMs = now.getTimezoneOffset() * 60000;
      return new Date(now.getTime() - tzOffsetMs).toISOString().slice(0, 16);
    },

    toPickerDate(value) {
      if (!value) return null;
      if (value instanceof Date) return value;
      const parsed = new Date(String(value).replace(" ", "T"));
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    },

    toIsoMinute(value) {
      if (!value) return "";
      const date = value instanceof Date ? value : new Date(String(value).replace(" ", "T"));
      if (Number.isNaN(date.getTime())) return "";
      const tzOffsetMs = date.getTimezoneOffset() * 60000;
      return new Date(date.getTime() - tzOffsetMs).toISOString().slice(0, 16);
    },

    onStartDateTimeChange(args) {
      this.eventoForm.start = this.toIsoMinute(args?.value);
    },

    onEndDateTimeChange(args) {
      this.eventoForm.end = this.toIsoMinute(args?.value);
    },

    normalizeDateTimeLocal(value, fallbackTime = "00:00") {
      if (!value) return "";
      const str = String(value).replace(" ", "T");
      const datePart = str.slice(0, 10);
      if (!/^\d{4}-\d{2}-\d{2}$/.test(datePart)) return "";
      const timeMatch = str.match(/T(\d{2}:\d{2})/);
      const timePart = timeMatch ? timeMatch[1] : fallbackTime;
      return `${datePart}T${timePart}`;
    },

    onDateClick(info) {
      const nowDateTime = this.getNowLocalDateTime();
      const currentTime = nowDateTime.slice(11, 16);
      const clickedDate = (info?.dateStr || "").slice(0, 10);
      const startDateTime = clickedDate
        ? `${clickedDate}T${currentTime}`
        : nowDateTime;
      this.eventoEditing = null;
      this.showNuevaCat = false;
      this.nuevaCatNombre = "";
      this.eventoForm = {
        title: "",
        start: startDateTime,
        end: "",
        allDay: false,
        description: "",
        categoria_id: this.categoriasSeleccionables[0]?.id || null,
        user_id: this.user?.id || null,
      };
      this.showModalEvento = true;
    },

    onSelect(info) {
      const nowTime = this.getNowLocalDateTime().slice(11, 16);
      this.eventoEditing = null;
      this.showNuevaCat = false;
      this.nuevaCatNombre = "";
      this.eventoForm = {
        title: "",
        start: this.normalizeDateTimeLocal(info.startStr, nowTime),
        end: this.normalizeDateTimeLocal(info.endStr, nowTime),
        allDay: info.allDay,
        description: "",
        categoria_id: this.categoriasSeleccionables[0]?.id || null,
        user_id: this.user?.id || null,
      };
      this.showModalEvento = true;
    },

    onEventClick(info) {
      const nowTime = this.getNowLocalDateTime().slice(11, 16);
      const ev = info.event;
      this.eventoEditing = ev.id;
      this.showNuevaCat = false;
      this.nuevaCatNombre = "";
      this.eventoForm = {
        title: ev.title,
        start: this.normalizeDateTimeLocal(ev.startStr, nowTime),
        end: this.normalizeDateTimeLocal(ev.endStr, nowTime),
        allDay: ev.allDay,
        description: ev.extendedProps?.description || "",
        categoria_id: ev.extendedProps?.categoria_id || null,
        user_id: ev.extendedProps?.user_id || this.user?.id || null,
      };
      this.showModalEvento = true;
    },

    async onEventDrop(info) {
      const ev = info.event;
      try {
        await axios.put(`/events/${ev.id}`, {
          title: ev.title,
          init_date: ev.startStr,
          end_date: ev.endStr || ev.startStr,
          all_day: ev.allDay ? 1 : 0,
          category_id: ev.extendedProps?.categoria_id,
          user_id: this.isAdmin
            ? ev.extendedProps?.user_id || this.user?.id
            : this.user?.id,
          description: ev.extendedProps?.description || "",
        });
      } catch (e) {
        info.revert();
        this.$notify({
          type: "danger",
          message: e.response?.data?.message || this.$t("server_error"),
        });
      }
    },

    async onGuardarCategoria() {
      if (!this.nuevaCatNombre.trim()) {
        this.$notify({ type: "warning", message: this.$t("Por favor completa todos los campos") });
        return;
      }
      this.savingCat = true;
      try {
        const { data } = await axios.post("/categories", {
          name: this.nuevaCatNombre.trim(),
          color: this.nuevaCatColor,
        });
        this.categorias.push({
          ...data,
          nombre: data.name,
          color: data.color || this.nuevaCatColor,
          visible: true,
        });
        this.categoriasCreadasIds.push(data.id);
        this.eventoForm.categoria_id = data.id;
        this.showNuevaCat = false;
        this.nuevaCatNombre = "";
        this.nuevaCatColor = "#2E9E4F";
        this.$notify({ type: "success", message: this.$t("Categoría creada correctamente") });
      } catch (e) {
        this.$notify({
          type: "danger",
          message: e.response?.data?.message || this.$t("server_error"),
        });
      } finally {
        this.savingCat = false;
      }
    },

    onEditarCategoria(cat) {
      this.editingCategoriaId = cat.id;
      this.editingCatNombre = cat.nombre || cat.name || "";
      this.editingCatColor = cat.color || "#2E9E4F";
    },

    onCancelarEditarCategoria() {
      this.editingCategoriaId = null;
      this.editingCatNombre = "";
      this.editingCatColor = "#2E9E4F";
      this.savingCatEdit = false;
    },

    async onGuardarEdicionCategoria(cat) {
      if (!this.editingCatNombre.trim()) {
        this.$notify({ type: "warning", message: this.$t("Por favor completa todos los campos") });
        return;
      }
      this.savingCatEdit = true;
      try {
        const { data } = await axios.put(`/categories/${cat.id}`, {
          name: this.editingCatNombre.trim(),
          color: this.editingCatColor,
        });
        const idx = this.categorias.findIndex((c) => c.id === cat.id);
        if (idx > -1) {
          this.categorias.splice(idx, 1, {
            ...this.categorias[idx],
            ...data,
            nombre: data?.name || this.editingCatNombre.trim(),
            color: data?.color || this.editingCatColor,
          });
        }
        this.filtrarEventos();
        this.$notify({ type: "success", message: this.$t("Categoría actualizada correctamente") });
        this.onCancelarEditarCategoria();
      } catch (e) {
        this.$notify({
          type: "danger",
          message: e.response?.data?.message || this.$t("server_error"),
        });
      } finally {
        this.savingCatEdit = false;
      }
    },

    onEliminarCategoria(cat) {
      this.$dialog.confirm({
        title: this.$t("Eliminar"),
        body: `¿Desea eliminar la categoría "${cat.nombre}"?`,
        okText: this.$t("Eliminar"),
        cancelText: this.$t("Cancelar"),
      }, { customClass: "cd-dialog cd-dialog--danger" })
        .then(async () => {
          try {
            await axios.delete(`/categories/${cat.id}`);
            this.categorias = this.categorias.filter((c) => c.id !== cat.id);
            this.categoriasCreadasIds = this.categoriasCreadasIds.filter(
              (id) => id !== cat.id,
            );
            if (this.eventoForm.categoria_id === cat.id) {
              this.eventoForm.categoria_id =
                this.categoriasSeleccionables[0]?.id || null;
            }
            if (this.editingCategoriaId === cat.id) {
              this.onCancelarEditarCategoria();
            }
            this.filtrarEventos();
            this.$notify({ type: "success", message: this.$t("Categoría eliminada correctamente") });
          } catch (e) {
            this.$notify({
              type: "danger",
              message: e.response?.data?.message || this.$t("server_error"),
            });
          }
        });
    },

    async onGuardarEvento() {
      if (!this.eventoForm.title || !this.eventoForm.categoria_id || !this.eventoForm.start || !this.eventoForm.user_id) {
        this.$notify({
          type: "warning",
          message: this.$t("Por favor completa todos los campos"),
        });
        return;
      }

      this.saving = true;
      const payload = {
        title: this.eventoForm.title,
        category_id: this.eventoForm.categoria_id,
        init_date: this.eventoForm.start,
        end_date: this.eventoForm.end || this.eventoForm.start,
        all_day: this.eventoForm.allDay ? 1 : 0,
        user_id: this.isAdmin ? this.eventoForm.user_id : this.user?.id,
        description: this.eventoForm.description || "",
      };
      try {
        if (this.eventoEditing) {
          const { data } = await axios.put(`/events/${this.eventoEditing}`, payload);
          const mapped = this._mapEvent(data);
          const idx = this.todosEventos.findIndex((e) => e.id == this.eventoEditing);
          if (idx > -1) this.todosEventos.splice(idx, 1, mapped);
          this.$notify({ type: "success", message: this.$t("event_updated") });
        } else {
          const { data } = await axios.post("/events", payload);
          this.todosEventos.push(this._mapEvent(data));
          this.$notify({ type: "success", message: this.$t("event_created") });
        }
        this.filtrarEventos();
        this.onCerrarModalEvento();
      } catch (e) {
        this.$notify({
          type: "danger",
          message: e.response?.data?.message || this.$t("server_error"),
        });
      } finally {
        this.saving = false;
      }
    },

    onEliminarEvento() {
      if (!this.eventoEditing) return;
      const eventoId = this.eventoEditing;
      this.$dialog.confirm({
        title: this.$t("Eliminar"),
        body: `¿Desea eliminar el evento "${this.eventoForm.title}"?`,
        okText: this.$t("Eliminar"),
        cancelText: this.$t("Cancelar"),
      }, { customClass: "cd-dialog cd-dialog--danger" })
        .then(async () => {
          this.deleting = true;
          try {
            await axios.delete(`/events/${eventoId}`);
            this.todosEventos = this.todosEventos.filter((e) => e.id != eventoId);
            this.filtrarEventos();
            this.$notify({ type: "success", message: this.$t("event_deleted") });
            this.onCerrarModalEvento();
          } catch (e) {
            this.$notify({
              type: "danger",
              message: e.response?.data?.message || this.$t("server_error"),
            });
          } finally {
            this.deleting = false;
          }
        })
        // The dialog rejects when the user cancels; nothing to do, but it has
        // to be handled so it does not surface as an unhandled rejection.
        .catch(() => {});
    },
  },
};
</script>

<style>
.nueva-cat-link {
  font-size: 12px;
  color: var(--cd-brand-green, #2E9E4F);
  text-decoration: none;
}
.nueva-cat-link:hover {
  color: var(--cd-brand-green-hover, #24803f);
  text-decoration: none;
}
.nueva-cat-box {
  background: var(--cd-surface-green-soft, #f2f8f3);
  border: 1px solid var(--cd-border-green-soft, #cfe6d6);
  border-radius: 8px;
  padding: 10px 12px;
}
.nueva-cat-box .form-control {
  background: #fff;
}
.nueva-cat-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
}
/* Fuera de .cd-modal estos botones no heredan el verde de marca y salían en
   el azul de Bootstrap por defecto. */
.nueva-cat-actions .btn-primary {
  background-color: var(--cd-brand-green, #2E9E4F) !important;
  border-color: var(--cd-brand-green, #2E9E4F) !important;
  color: #fff !important;
}
.nueva-cat-actions .btn-primary:hover,
.nueva-cat-actions .btn-primary:focus {
  background-color: var(--cd-brand-green-hover, #24803f) !important;
  border-color: var(--cd-brand-green-hover, #24803f) !important;
}
/* Mismo "Cancelar" neutro que ya usan los modales de la app (.cd-modal
   .btn-secondary): fondo blanco, borde gris claro, texto apagado — este
   botón, al no estar dentro de un .cd-modal (vive en el panel lateral de
   categorías), no heredaba ese estilo y salía con el azulado de Bootstrap. */
.nueva-cat-actions .btn-secondary {
  background-color: #fff !important;
  border-color: var(--cd-border-light, #e2e5ec) !important;
  color: var(--cd-text-muted, #8a8f9c) !important;
}
.nueva-cat-actions .btn-secondary:hover,
.nueva-cat-actions .btn-secondary:focus {
  background-color: #f6f7f9 !important;
  border-color: var(--cd-border-light, #e2e5ec) !important;
  color: var(--cd-text-body, #4a4f5a) !important;
}

.agenda-ejs-datetime {
  width: 100%;
}

.agenda-ejs-datetime .e-input-group-icon.e-date-icon,
.agenda-ejs-datetime .e-input-group-icon.e-time-icon {
  display: inline-flex !important;
  width: 30px;
  min-width: 30px;
  align-items: center;
  justify-content: center;
  opacity: 1 !important;
  visibility: visible !important;
}

.e-datetimepicker.e-popup-wrapper,
.e-datepicker.e-popup-wrapper,
.e-timepicker.e-popup-wrapper,
.e-calendar.e-popup-wrapper,
.e-datetimepicker.e-popup,
.e-datepicker.e-popup,
.e-timepicker.e-popup,
.e-calendar.e-popup {
  z-index: 10060 !important;
}

.agenda-layout {
  margin: 0;
  align-items: stretch;
  flex: 1 1 auto;
  min-height: 0;
}

.agenda-card-body {
  padding: 14px 18px 18px;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 190px);
}

.agenda-calendar-panel {
  /* border: 1px solid #dfe3e8; */
  background: #fff;
  height: 100%;
  padding-bottom: 10px;
  box-sizing: border-box;
}

.agenda-calendar {
  /* padding: 10px 10px 0; */
  height: 100%;
  display: flex;
  flex-direction: column;
  --fc-list-event-hover-bg-color: var(--cd-surface-green-soft, #f2f8f3);
}

.agenda-filters-col {
  box-sizing: border-box;
  padding-bottom: 10px;
}

.agenda-filters-panel {
  border: 1px solid var(--cd-border-light, #e2e5ec);
  background: #fff;
  padding: 0;
  height: 100%;
  box-sizing: border-box;
}

.agenda-filters-header {
  background: var(--cd-surface-green-soft, #f2f8f3);
  color: var(--cd-brand-green-dark, #0f5c2e);
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .04em;
  padding: 8px 10px;
  border-bottom: 1px solid var(--cd-border-green-soft, #cfe6d6);
}

.agenda-filters-body {
  padding: 12px 12px 8px;
}

.agenda-cat-item {
  width: 100%;
}

.agenda-cat-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.agenda-cat-row .cd-checkbox {
  margin-bottom: 0;
  min-width: 0;
}
.agenda-cat-row .cd-checkbox__text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agenda-cat-color-dot {
  width: 10px;
  height: 10px;
  flex-shrink: 0;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.12);
  margin: 0 6px 0 2px;
}

.agenda-cat-row-actions {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.agenda-cat-edit-box {
  background: var(--cd-surface-green-soft, #f2f8f3);
  border: 1px solid var(--cd-border-green-soft, #cfe6d6);
  border-radius: 8px;
  padding: 10px 12px;
}
.agenda-cat-edit-box .form-control {
  background: #fff;
}

.agenda-cat-edit-color {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
}
.agenda-cat-edit-color-label {
  font-size: 12px;
  color: var(--cd-text-muted, #8a8f9c);
}

.agenda-color-input {
  width: 40px;
  height: 34px;
  padding: 2px;
  border: 1px solid var(--cd-border-green-soft, #cfe6d6);
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
}
.agenda-color-input::-webkit-color-swatch-wrapper {
  padding: 2px;
}
.agenda-color-input::-webkit-color-swatch {
  border: none;
  border-radius: 3px;
}

/* The category filters used to be a hand-rolled checkbox (hidden input plus a
   span with a blue tick). They now use .cd-checkbox, so those rules are gone
   along with the markup that needed them. */

.agenda-calendar .fc .fc-toolbar {
  margin-bottom: 0;
  padding: 5px 0 5px;
  border: 1px solid var(--cd-border-light, #e2e5ec);
  background-color: var(--cd-surface-green-soft, #f2f8f3);
}

.agenda-calendar .fc .fc-toolbar-title {
  font-size: 22px;
  font-weight: 400;
  color: var(--cd-brand-green-dark, #0f5c2e);
  text-transform: none;
  margin-left: 10px;
}

.agenda-calendar .fc .fc-button {
  background: #ffffff00 !important;
  border: 1px solid #e5e9ef00 !important;
  color: var(--cd-text-muted, #8a8f9c) !important;
  border-radius: 0;
  box-shadow: none !important;
  font-size: 12px;
  font-weight: 500;
  padding: 0.3rem 0.7rem;
  line-height: 1.4;
}

.fc-button-primary {
  background-color: #fff !important;
  border-color: var(--cd-border-light, #e2e5ec) !important;
}

.agenda-calendar .fc .fc-button-group > .fc-button {
  margin: 0 !important;
}

.agenda-calendar .fc .fc-printButton-button::before {
  content: "\f02f";
  font-family: "Font Awesome 5 Free", "FontAwesome";
  font-weight: 900;
  display: inline-block;
  margin-right: 6px;
}

.agenda-calendar .fc .fc-prev-button,
.agenda-calendar .fc .fc-next-button {
  width: 34px;
  padding: 0.3rem 0 !important;
  font-size: 13px;
  font-weight: 700;
}

.agenda-calendar .fc .fc-toolbar-chunk:last-child .fc-button {
  border-left-width: 0 !important;
}

.agenda-calendar .fc .fc-toolbar-chunk:last-child .fc-button:first-child,
.agenda-calendar
  .fc
  .fc-toolbar-chunk:last-child
  .fc-button-group
  .fc-button:first-child {
  border-left-width: 1px !important;
}

.fc-button-primary:not(:disabled).fc-button-active,
.fc-button-primary:not(:disabled):active,
.agenda-calendar .fc .fc-button:hover {
  background-color: var(--cd-surface-green-soft, #f2f8f3) !important;
  /* border-color: #d6dde5 !important; */
  color: var(--cd-brand-green-dark, #0f5c2e) !important;
}

.fc .fc-button .fc-icon {
  font-weight: 600;
}

.agenda-calendar .fc .fc-col-header-cell {
  background: var(--cd-surface-green-soft, #f2f8f3);
  border: 1px solid var(--cd-border-light, #e2e5ec);
}

.agenda-calendar .fc .fc-col-header-cell-cushion {
  color: var(--cd-brand-green-dark, #0f5c2e);
  font-size: 12px;
  font-weight: 700;
  text-transform: capitalize;
  padding: 7px 4px;
  text-decoration: none;
}

.agenda-calendar .fc .fc-daygrid-day-number {
  color: var(--cd-text-body, #4a4f5a);
  font-size: 12px;
  text-decoration: none;
  padding: 4px 6px;
}

.agenda-calendar .fc .fc-list-day-cushion {
  background: #eeeeef;
}

.agenda-calendar .fc .fc-list-day-text {
  color: var(--cd-text-muted, #8a8f9c) !important;
  font-weight: 600;
  text-decoration: none;
}

.agenda-calendar .fc .fc-list-day-side-text {
  color: var(--cd-text-muted, #8a8f9c) !important;
  font-weight: 500;
}

.agenda-calendar .fc .fc-daygrid-day-frame {
  min-height: 82px;
}

.agenda-calendar .fc .fc-day-today {
  background: var(--cd-surface-green-soft, #f2f8f3) !important;
}

.agenda-calendar .fc .fc-day-other .fc-daygrid-day-number {
  color: #a7b1ba;
}

.agenda-calendar .fc .fc-daygrid-more-link {
  color: var(--cd-text-muted, #8a8f9c) !important; /* color del +2 más */
  font-weight: 600;
}

.agenda-calendar .fc .fc-daygrid-more-link:hover {
  color: var(--cd-brand-green-hover, #24803f) !important;
}

.agenda-calendar .fc .fc-daygrid-day,
.agenda-calendar .fc .fc-scrollgrid,
.agenda-calendar .fc .fc-scrollgrid td,
.agenda-calendar .fc .fc-scrollgrid th {
  border-color: var(--cd-border-light, #e2e5ec);
}

/* .agenda-calendar .fc .fc-daygrid-event:hover,
.agenda-calendar .fc .fc-timegrid-event:hover {
  background-color: #2d7fca !important;
  border-color: #2d7fca !important;
} */

.agenda-calendar .fc .fc-list-event:hover td {
  background-color: var(--cd-surface-green-soft, #f2f8f3) !important;
  border-color: var(--cd-surface-green-soft, #f2f8f3) !important;
  /* color: #ffffff !important; */
}


.agenda-calendar .fc .fc-list-event td,
.agenda-calendar .fc .fc-list-event a,
.agenda-calendar .fc .fc-list-event .fc-event-main {
  transition: none !important;
}

.agenda-calendar .fc .fc-list-event:hover .fc-event-main,
.agenda-calendar .fc .fc-list-event:hover .fc-event-title,
.agenda-calendar .fc .fc-list-event:hover .fc-list-event-title a {
  background: transparent !important;
}

/* .agenda-calendar .fc .fc-list-event:hover a {
  color: #ffffff !important;
} */

/* .agenda-calendar .fc .fc-list-event:hover .fc-list-event-dot {
  border-color: #ffffff !important;
} */

.agenda-calendar .fc .fc-col-header,
.agenda-calendar .fc .fc-scrollgrid-sync-table,
.agenda-calendar .fc .fc-daygrid-body,
.agenda-calendar .fc .fc-daygrid-body table {
  width: 100% !important;
}

.agenda-calendar .fc .fc-event {
  border: 1px solid var(--cd-brand-green, #2E9E4F);
  border-radius: 2px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 1px 4px;
  cursor: pointer;
}

.agenda-calendar .fc .fc-list,
.agenda-calendar .fc .fc-list-table {
  border-color: var(--cd-border-light, #e2e5ec);
}

.agenda-calendar .fc .fc-scrollgrid-liquid {
  border-bottom-width: 0;
}

@media (max-width: 991px) {
  .agenda-card-body {
    padding: 12px;
    min-height: auto;
    display: block;
  }

  .agenda-calendar-panel,
  .agenda-filters-panel {
    height: auto;
  }

  .agenda-calendar .fc .fc-toolbar {
    flex-direction: column;
    gap: 0.5rem;
    align-items: flex-start;
  }

  .agenda-calendar .fc .fc-toolbar-chunk {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
  }
}
</style>
